import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {from, Observable} from "rxjs";

export interface TextDialogModel {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  templateUrl: "./text-dialog.template.pug",
})
export class TextDialogComponent extends DialogComponent<TextDialogModel, any | null> implements TextDialogModel {
  message: string;
  title: string;
  confirmText: string;
  cancelText: string;
  inputText: string = ''; // Add inputText property
  errors: Error | undefined;

  static showConfirmationDialogModal(dialogService: DialogService, inputs: TextDialogModel):
  Observable<any | null> {
    return from(dialogService.showDialog(TextDialogComponent, inputs, {backdropColor: "rgba(0, 0, 0, 0.5)"}));
  }

  cancel(): void {
    this.result = null;
    this.close();
  }

  ok(): void {
    this.result =  this.inputText && this.inputText.trim(); // Change this.message to this.inputText
    if (!this.result) {
      this.errors = new Error("A reason is required for deleting this project");
      // Handle the error without returning it
      return;
    } else {
      this.errors = undefined;
      this.close();
    }
    this.close();
  }

  constructor(
    public dialogService: DialogService,
  ) {
    super(dialogService);
  }
}
